export default __webpack_public_path__ + "c94bdea947a0930621ed1b2abd04b629.png";